import clsx from 'clsx';
import { Box, BoxProps } from 'grommet';
import { LoaderCircleIcon } from 'lucide-preact';

import style from './style.scss';

interface LoaderSpinnerProps {
  color?: string;
  fill?: BoxProps['fill'];
  className?: string;
  absolute?: boolean;
}

const LoaderSpinner = ({ color = 'white', fill, className, absolute }: LoaderSpinnerProps) => (
  <Box
    className={clsx(style.animation, className, { [style.absolute]: absolute })}
    fill={fill}
    justify="center"
    align="center"
  >
    <LoaderCircleIcon
      className="size-[1em] animate-spin"
      color={color}
      style={{ verticalAlign: 'middle', fontSize: '50px' }}
    />
  </Box>
);

export default LoaderSpinner;
